import { Capacitor } from "@capacitor/core";
import WebEncryptedStorage from "./webEncryptedStorage";
import NativeEncryptedStorage from "./nativeEncryptedStorage";
import type { SecureStorage } from "./types";

let store: SecureStorage | null = null;

export function setDbStore(newDbStore: SecureStorage | null) {
  store = newDbStore;
}

export default function db(): SecureStorage {
  if (store) {
    return store;
  }

  const dbStore = Capacitor.isNativePlatform()
    ? new NativeEncryptedStorage()
    : new WebEncryptedStorage();
  setDbStore(dbStore);
  return store!;
}

export * from "./types";
